import React, { useEffect, useState } from 'react';
import ContentRow from '../components/ContentRow';
import Hero from '../components/Hero';
import { endpoints, getList } from '../api/tmdb';
import { useApp } from '../context/AppContext';
import { filterForKids } from '../utils/kidsFilter';

const Movies = () => {
  const { profile } = useApp();
  const isKids = !!profile?.is_kids;
  const [hero, setHero] = useState(null);
  const [rows, setRows] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const [popular, top, now, upcoming, action, comedy, horror, scifi] = await Promise.all([
        getList(endpoints.popularMovies),
        getList(endpoints.topMovies),
        getList(endpoints.nowPlaying),
        getList(endpoints.upcoming),
        getList(endpoints.genreMovies, { with_genres: 28, sort_by: 'popularity.desc' }),
        getList(endpoints.genreMovies, { with_genres: 35, sort_by: 'popularity.desc' }),
        getList(endpoints.genreMovies, { with_genres: 27, sort_by: 'popularity.desc' }),
        getList(endpoints.genreMovies, { with_genres: 878, sort_by: 'popularity.desc' }),
      ]);
      const f = (a) => filterForKids(a, isKids);
      const popF = f(popular);
      setHero(popF.find((p) => p.backdrop_path) || popF[0]);
      setRows({
        'Popular Movies': popF,
        'Top Rated': f(top),
        'Now Playing': f(now),
        'Coming Soon': f(upcoming),
        'Action & Adventure': f(action),
        'Comedy': f(comedy),
        ...(isKids ? {} : { 'Horror': f(horror) }),
        'Sci-Fi': f(scifi),
      });
      setLoading(false);
    })();
  }, [isKids]);

  return (
    <div>
      <Hero item={hero} />
      <div className="relative -mt-24 z-10">
        <div className="mx-10 mb-6 px-5 py-3 rounded-xl bg-white/5 border border-white/10 text-sm text-white/70">
          <span className="text-white font-semibold">Movie discovery.</span> Browse trailers, ratings, and recommendations. Full-length movies available on the studios&apos; own streaming services.
        </div>
        {Object.entries(rows).map(([title, items], i) => (
          <ContentRow key={title} title={title} items={items} loading={loading} variant={i === 0 ? 'backdrop' : 'poster'} />
        ))}
        <div className="px-10 py-8 text-center text-white/40 text-xs">
          Metadata provided by <a href="https://www.themoviedb.org/" target="_blank" rel="noreferrer" className="text-white/60 hover:text-white">TMDB</a>.
        </div>
      </div>
    </div>
  );
};

export default Movies;
